<template>
  <div>
    <videoplayer v-bind:postsrc="'/videos/StoryAtelier/1.mp4'" v-bind:autoplay="true"></videoplayer>
  </div>
</template>

<style scoped>
</style>

<script>
import videoplayer from '@/components/Includes/videoplayer.vue'
export default {
  name: 'STmain',
  components: {
    videoplayer
  },
  props: {
    msg: String
  },
  mounted () {
    document.body.style.background = 'rgb(252, 202, 129)'
    document.getElementsByTagName('nav')[0].style.background = 'rgb(252, 202, 129)'
    this.$store.commit('toggleMenu', false)
  }
}
</script>
